import {
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  Page,
  PageRoute,
  ScreenType,
  useParams,
  useValidationErrors,
} from "@compass/core";
import {
  ApplicationResponseFile,
  FileTypeCategory,
  Permission,
  StudentApplicationEditResource,
  StudentFile,
  StudentServiceFile,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { studentPageRoute } from "pages/students/students/StudentPage/StudentPage";
import { createEntity } from "utils";
import { FileDetailHeader } from "./FileDetailHeader";
import { FileDetailBody } from "./FileDetailBody";
import { FileDetailTypeEnum } from "./FileDetailTypeEnum";

export const FileDetail = (props: {
  fileType: FileTypeCategory;
  parentEntityId: number;
  entityId: number;
  crudMode: CrudMode;
  screenType: ScreenType;
  open: boolean;
  onChange: (file: StudentServiceFile | StudentFile | ApplicationResponseFile) => void;
  onCancel?: () => void;
}) => {

  const navigate = useNavigate();
  const [applicationFileResource, setApplicationFileResource] = useState<StudentApplicationEditResource>();
  const [applicationResponseFile, setApplicationResponseFile] = useState<ApplicationResponseFile>();
  const [studentServiceFile, setStudentServiceFile] = useState<StudentServiceFile>();
  const [studentFile, setStudentFile] = useState<StudentFile>();

  useEffect(() => {
    ApiService.studentApplications.getFileEditResource()
      .then((response) => {
        setApplicationFileResource(response);
      });

    if (props.entityId != 0) {
      if (props.fileType == FileTypeCategory.Application) {
        ApiService.studentApplications.getApplicationResponseFile(props.entityId)
          .then((response) => {
            setApplicationResponseFile(response);
          });
      }
      else if (props.fileType == FileTypeCategory.StudentServiceFile) {
        ApiService.studentServices.getStudentServiceFile(props.entityId)
          .then((response) => {
            setStudentServiceFile(response);
          });
      }
      else {
        ApiService.studentFiles.get(props.entityId)
          .then((response) => {
            response.studentId = props.parentEntityId;
            setStudentFile(response);
          });
      }
    }
    else {
      if (props.fileType == FileTypeCategory.Application) {
        let newFile: ApplicationResponseFile = createEntity<ApplicationResponseFile>({
          applicationResponseId: props.parentEntityId
        });
        setApplicationResponseFile(newFile);

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
      else if (props.fileType == FileTypeCategory.StudentServiceFile) {
        let newFile: StudentServiceFile = createEntity<StudentServiceFile>({
          studentServiceId: props.parentEntityId
        });
        setStudentServiceFile(newFile);

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
      else {
        ApiService.studentFiles.get(props.entityId)
          .then((response) => {
            response.studentId = props.parentEntityId;
            setStudentFile(response);
          });

        ApiService.studentApplications.getFileEditResource()
          .then((response) => {
            setApplicationFileResource(response);
          });
      }
    }

  }, []);

  const fetchGet = (id: number) => {
    if (props.fileType == FileTypeCategory.Application) {
      ApiService.studentApplications.getApplicationResponseFile(props.entityId)
        .then((response) => {
          setApplicationResponseFile(response);
        });
    }
    else if (props.fileType == FileTypeCategory.StudentServiceFile) {
      ApiService.studentServices.getStudentServiceFile(props.entityId)
        .then((response) => {
          setStudentServiceFile(response);
        });
    }
    else {
      ApiService.studentFiles.get(props.entityId)
        .then((response) => {
          response.studentId = props.parentEntityId;
          setStudentFile(response);
        });
    }
  };

  const pageHeader = (
    <FileDetailHeader
      crudMode={props.crudMode}
      applicationResponseFile={applicationResponseFile}
      studentFile={studentFile}
      studentServiceFile={studentServiceFile}
      // parentEntityId={props.parentEntityId}
      entityId={props.entityId}
      fileType={props.fileType}
      onFileChange={(file) => props.onChange(file)}
      onSave={(id) => {
        
      }}
    />
  );

  const pageBody = (
    <FileDetailBody
      fileType={props.fileType}
      crudMode={props.crudMode}
      applicationFileResource={applicationFileResource}
      applicationResponseFile={applicationResponseFile}
      studentFile={studentFile}
      studentServiceFile={studentServiceFile}
      setEditingStudentFile={setStudentFile}
      setEditingStudentServiceFile={setStudentServiceFile}
      setEditingApplicationResponseFile={setApplicationResponseFile}
    />
  );

  return props.screenType === "standard" ? (
    <>
      <Page isForm header={pageHeader}>
        {pageBody}
      </Page>
    </>
  ) : (
    <Dialog
      isForm
      open={props.open}
      onClose={() => handleClose(navigate)}
      maxWidth="lg"
      header={pageHeader}
      content={pageBody}
    />
  );
};
